import { IGroupByListColumn } from "models";

const DATE_RANGE_SUBGROUP = "Date Range";
const NOT_APPLICABLE_GROUP_NAME = "Not Applicable With Date Range";

interface FieldGroup {
  key: string;
  fields: IGroupByListColumn[];
}

/**
 * Applies date-range-aware grouping for Performance fields.
 *
 * - When `hasDateRange` is true: splits fields into two virtual groups:
 *   1. "Date Range" — fields from the "Date Range" subgroup (shown at top)
 *   2. "Not Applicable With Date Range" — all remaining fields merged
 *
 * - When `hasDateRange` is false: filters OUT the "Date Range" subgroup entirely,
 *   returning only the remaining groups in their original order.
 */
const groupFieldsByDateRange = (
  groups: FieldGroup[],
  hasDateRange: boolean
): FieldGroup[] => {
  if (!groups.length) return groups;

  if (hasDateRange) {
    const dateRangeGroup = groups.find((g) => g.key === DATE_RANGE_SUBGROUP);
    const otherGroups = groups.filter((g) => g.key !== DATE_RANGE_SUBGROUP);

    const result: FieldGroup[] = [];

    if (dateRangeGroup && dateRangeGroup.fields.length > 0) {
      result.push(dateRangeGroup);
    }

    const otherFields = otherGroups.flatMap((g) => g.fields);
    if (otherFields.length > 0) {
      result.push({ key: NOT_APPLICABLE_GROUP_NAME, fields: otherFields });
    }

    return result;
  }

  // No date range: hide the "Date Range" subgroup entirely
  return groups.filter((g) => g.key !== DATE_RANGE_SUBGROUP);
};

export default groupFieldsByDateRange;
